(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("purchHeadCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 687,
                    parameters: parms || {}
                });
            },
            createObj: function (edit) {
                return $ihttp.post({
                    method: 688,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
